module.exports = __webpack_public_path__ + "images/kaitori_bonus_cp_lp/step-1_0e3d2827622a38c72c6a48d074dfddd4.png";